// const getScrollbarWidth = () => {
//   return window.innerWidth - document.documentElement.clientWidth
// }

var player;

window.onYouTubeIframeAPIReady = function() {
  player = new YT.Player('youtube_video', {
    events: {
      'onReady': onPlayerReady
    }
  })
}

function onPlayerReady(event) {
  var pauseButton = document.getElementById("pause-button");
  pauseButton.addEventListener("click", function() {
    //console.log('pause-button')
    player.pauseVideo();
  });
}


const showModal = (modalShowClass, documentShowClass) => (
  modalElement,
) => () => {
  document.documentElement.classList.add(documentShowClass)
  // document.documentElement.style.marginRight = getScrollbarWidth() + 'px'
  // document.documentElement.style.overflow = 'hidden'
  modalElement.classList.add(modalShowClass)
}

const hideModal = (modalShowClass, documentShowClass) => (
  modalElement,
) => () => {
  document.documentElement.classList.remove(documentShowClass)
  // document.documentElement.style.marginRight = null
  // document.documentElement.style.overflow = null
  modalElement.classList.remove(modalShowClass)

  /*var iframe = document.querySelector( '#youtube_video');
  var video = iframe.querySelector( 'video' );
  console.log(video)
  if ( video !== null ) {
    video.pause();
  }*/

  player.pauseVideo();

}

const clickOnModal = (hideModalCallback) => (event) => {
  if (event.currentTarget === event.target) {
    hideModalCallback()
  }
  event.stopPropagation()
}

export default (
  openModalElementId,
  closeModalElementId,
  modalElementId,
  modalShowClass,
  documentShowClass,
  youtubeId,
) => {
  const modalElement = document.getElementById(modalElementId)
  if (!modalElement) {
    return
  }


  document
    .getElementById(openModalElementId)
    .addEventListener(
      'click',
      showModal(modalShowClass, documentShowClass)(modalElement),
    )
  document
    .getElementById(closeModalElementId)
    .addEventListener(
      'click',
      hideModal(modalShowClass, documentShowClass)(modalElement),
    )
  modalElement.addEventListener(
    'click',
    clickOnModal(hideModal(modalShowClass, documentShowClass)(modalElement)),
  )
}
